

export const personalGreen = "#A8EF20"
export const personalOrange = "orange"
export const personalRed = "red"
export const titleColor= "#495672"